<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    total_items: {
      type: Number,
      required: false,
    },
    total_active_items: {
      type: Number,
      required: false,
    },
    model_length: {
      type: Number,
      required: false,
    },
    toggleModal: {
      type: Function,
      required: false
    },
    selectUnSelectBtn: {
      type: Boolean,
      required: false
    }
  },
};
</script>
<template>
    <div class="d-flex">
        <label
            class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium">
            {{item.label}}
            <span v-if="item.required"> *</span>  
        </label>
        <img v-if="item.info" variant="primary" class="align-self-center" src="@/assets/images/info.svg" alt="">
        <b-tooltip :target="item.label || ''">{{item.tooltip ? item.tooltip : 'Enter ' + item.label}}</b-tooltip>
        <p v-if="item.character_count > 0"
            class="font-size-14 mb-2 font-weight-medium text-muted ml-auto align-self-sm-center">
            Character Count: {{model_length}} / {{item.character_count}}
        </p>  
        <a v-if="item.label == 'Sub-groups'"
        class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer font-weight-medium"
        @click="toggleModal">+ Add Item</a>     
        <p v-if="item.type == 'list'" class="font-size-14 mb-2 text-muted ml-auto align-self-sm-center">
            <span>Total: {{total_items}} </span><span class="mx-1">|</span><span> Active: {{total_active_items}}</span>
        </p>
    </div>
</template>